import axios from "axios";

export const state = {
    suppliers: [],
};

export const getters = {
    suppliers: state => state.suppliers,
};

export const mutations = {
    setSupplier(state, newValue) {
        state.suppliers = newValue
    },
};

export const actions = {
    fetchSuppliers({ commit }) {
        axios.get('/suppliers').then(res => {
            commit('setSupplier', res.data.suppliers);
        })
    },
};
